
import {Address} from '../models/address.models';
import {Booking} from '../models/booking.models';
import {Chat} from '../models/chat.models';
import {Message} from '../models/message.models';
import {Observable} from 'rxjs';
import {User} from '../models/user.models';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {SubService} from '../models/subService.models';
import {Constants} from '../models/contants.models';

@Injectable({
    providedIn: 'root',
})
export class Online {
    // apiBase = 'https://hausaid.com/sp_admin/public/api/';
    // apiBase = 'https://fixitqatar.com/spadmin/public/api/';
    apiBase = 'http://127.0.0.1:8000/api/';
    user: User;
    token: string;
    constructor( private http: HttpClient) {
      //  this.user = JSON.parse(window.localStorage.getItem(Constants.KEYUser));
       // this.token = JSON.parse(window.localStorage.getItem(Constants.KEYToken));
    }

}
